import { createFileRoute } from "@tanstack/react-router";
import { UserIcon } from "../../components/icons/sidebar-icons";
import { ModulePlaceholder } from "../../components/modules/module-placeholder";

export const Route = createFileRoute("/_app/profile")({
	component: () => <ModulePlaceholder messageKey="profile.message" icon={UserIcon} />,
});
